function CompanyData() {
	return (
		<div className="page__companydata">
			<h1 className="header">Company Data</h1>
		</div>
	);
}

export default CompanyData;
